module.exports = __webpack_public_path__ + "static/media/what_we_do.6d92d646.svg";